import { Navigate } from 'react-router-dom';

export const GraphiQLTool = () => {
  return <Navigate to="/graphiql" replace />;
};
